import React from "react";
import { Button, Col, Container, FormLabel, Row } from "react-bootstrap";
import {
  FabricStyleCostMaintenanceSearchCriteria,
  PageListBean,
  RestFabricStyleCostMaintenanceListRequest,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleService } from "../services/FabricStyleService.js";

export class FabricCostLookupHandler extends LookupHandler {
  constructor(companyCode, attribute_name, customerCode) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new FabricStyleCostMaintenanceSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let newCriteria = new FabricStyleCostMaintenanceSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let fabricCostLookupCriteria =
      new FabricStyleCostMaintenanceSearchCriteria();
    fabricCostLookupCriteria.companyCode = this.companyCode;
    let lookupCriteriaView = FabricCostLookupCriteraHandler(
      companyCode,
      fabricCostLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      fabricCostLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition("Description", "description", 0, false); //2
    this.addColumnDefinition("Cost", "cost", 0, false); //3
  }
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.costMaintenanceNumberContains)) {
      if (!isEmptyString(filterText)) {
        search.costMaintenanceNumberContains = filterText;
        this.searchCriteria = new FabricStyleCostMaintenanceSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadFabricCostList(lookup_dialog, pageNumber, search);
    }
  }
  loadFabricCostList = (lookup_dialog, pageNumber, searchCriteria) => {
    let criteria = new FabricStyleCostMaintenanceSearchCriteria(); //To be fetched from CriteriaHandler
    criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      criteria.costMaintenanceNumberContains =
        searchCriteria.costMaintenanceNumberContains;

      criteria.costMaintenanceNumberStartsWith =
        searchCriteria.costMaintenanceNumberStartsWith;
      criteria.costMaintenanceNumber = searchCriteria.costMaintenanceNumber;
    }
    let pageList = new PageListBean();
    pageList.pageSize = 50; //TODO --> Fetch from Config
    pageList.currentPage = pageNumber;
    pageList.pageNumber = pageNumber;
    let requestInput = new RestFabricStyleCostMaintenanceListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    FabricStyleService.getFabricStyleCostMaintenancePageList(
      requestInput,
      (response) => this.loadFabricCostListResponse(response, lookup_dialog),
      this.loadFabricCostListError
    );
  };
  loadFabricCostListResponse = (response, lookup_dialog) => {
    let fabricCostList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStyleCostMaintenancePageList) &&
      !isEmptyArray(
        response.data.fabricStyleCostMaintenancePageList
          .fabricStyleCostMaintenanceBeans
      )
    ) {
      fabricCostList =
        response.data.fabricStyleCostMaintenancePageList
          .fabricStyleCostMaintenanceBeans;
      totalCount = response.data.fabricStyleCostMaintenancePageList.totalCount;
      currentPageNumber =
        response.data.fabricStyleCostMaintenancePageList.currentPage;
      pageSize = response.data.fabricStyleCostMaintenancePageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = fabricCostList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadFabricCostListError = (error) => {
    ShowError("Error : " + error);
  };
}
const FabricCostLookupCriteraHandler = (
  companyCode,
  fabricCostLookupCriteria
) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new FabricStyleCostMaintenanceSearchCriteria(),
        is3PL: false,
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    }
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      this.setState({
        searchCriteria: new FabricStyleCostMaintenanceSearchCriteria(),
      });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      const is3PL = this.state.is3PL;
      return (
        <div>
          <Container>
            <Row>
              <Col sm={5}>
                <FormLabel>CostMaintenanceNumber</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="costMaintenanceNumber"
                  name="costMaintenanceNumber"
                  onChange={this.onChange}
                  value={searchCriteria.costMaintenanceNumber}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CostMaintenanceNumber Starts With</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="costMaintenanceNumberStartsWith"
                  name="costMaintenanceNumberStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.costMaintenanceNumberStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>CostMaintenanceNumber Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  tabIndex={-1}
                  id="costMaintenanceNumberContains"
                  name="costMaintenanceNumberContains"
                  onChange={this.onChange}
                  value={searchCriteria.costMaintenanceNumberContains}
                />
              </Col>
            </Row>

            <Row className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </Row>
          </Container>
        </div>
      );
    }
  };
};
